import ServicioRegistroDeItem from "../../isp.servicios.items/ServicioRegistroDeItem";
import ComandoAPI from "./ComandoAPI";

export default class ComandoRegistrarItem extends ComandoAPI {
    constructor() {
        super();
        this.servicio = new ServicioRegistroDeItem();
    }
}
